import ProjectTeamMemberComponent from './member.component'

const ProjectTeamMemberModule = angular.module('cdbl.project-team.member', [

])
  .component('cdblProjectTeamMember', ProjectTeamMemberComponent)
  .name

export default ProjectTeamMemberModule
